import Vue from 'vue'
import App from './App.vue'

// Vuesax 
import Vuesax from 'vuesax'
Vue.use(Vuesax)

// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// Theme Configurations
import '../siteConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Vue Router
import router from './router'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


import VueMeta from 'vue-meta'
Vue.use(VueMeta)
// PrismJS
import 'prismjs'
// import 'prismjs/themes/prism-tomorrow.css'

//Firebase
import '@/firebase/firebaseConfig'

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// Feather font icon
//require('./assets/css/iconfont.css')




// BootStrapVue
import { CarouselPlugin } from 'bootstrap-vue'
Vue.use(CarouselPlugin)
import { NavbarPlugin } from 'bootstrap-vue'
Vue.use(NavbarPlugin)

Vue.config.productionTip = false

// GOOGLE ANALYTICS
import { irisConfig } from "@/../siteConfig.js";
import VueAnalytics  from 'vue-analytics'
Vue.use (VueAnalytics, { 
  id: irisConfig.googleAnalyticsID, 
  router 
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#wrapper')

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

